export const blockedCardEventTypeLabels = {
  CardBlockAdded: {
    label: 'Block Added',
    className: 'warning',
  },
  CardBlockEnforced: {
    label: 'Block Enforced',
    className: 'critical',
  },
  CardBlockRemoved: {
    label: 'Block Removed',
    className: 'info',
  },
};
